import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PointagePage from './pages/PointagePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminSites from './pages/AdminSites';
import AdminPlanningsNew from './pages/AdminPlanningsNew';
import AdminCompteRendu from './pages/AdminCompteRendu';
import AdminEmailRecaps from './pages/AdminEmailRecaps';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PointagePage />} />
          <Route path="/admin/login" element={<Navigate to="/" replace />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/sites" element={<AdminSites />} />
          <Route path="/admin/secteurs" element={<AdminSites />} />
          <Route path="/admin/plannings" element={<AdminPlanningsNew />} />
          <Route path="/admin/compte-rendu" element={<AdminCompteRendu />} />
          <Route path="/admin/email-recaps" element={<AdminEmailRecaps />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;